// Shared asset-URL helpers. Neutral utils layer so both the asset gallery
// (routes/asset-gallery) and the Image Lab (labs/ImageLab) can resolve
// backend-relative media URLs without a cross-feature import.

import { API_BASE_URL } from '../services/api';

/**
 * Absolute URL for streaming an asset's bytes by id
 * (`{base}/api/v3/assets/files/{id}`). Used where we only have an asset id —
 * collection cover thumbnails and lineage thumbnails — since there's no Vite
 * proxy and a bare relative path would resolve against the FE origin.
 */
export function assetFileUrl(assetId: string): string {
  return `${API_BASE_URL}/api/v3/assets/files/${assetId}`;
}

/**
 * Resolve a possibly-relative media URL to an absolute one. Backend asset
 * `url`/`thumbnailUrl` usually come back absolute, but some surfaces return a
 * relative path (e.g. collection `coverThumbnailUrl` = `/api/v3/assets/files/{id}`,
 * or studio swatch thumbnails); prepend the API base for those so `<img src>`
 * hits the backend, not the FE origin. Leaves `data:`/`blob:`/absolute URLs alone.
 */
export function resolveAssetUrl(url?: string): string | undefined {
  if (!url) return undefined;
  if (/^(https?:|data:|blob:)/i.test(url)) return url;
  return `${API_BASE_URL}${url.startsWith('/') ? '' : '/'}${url}`;
}
